import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { StyledWrapper, StyledText } from '../UnavailableByBooking/UnavailablebyBooking.styles';
import { StyledContainer } from '../UnavailableSeat.styles';

const UnavailableByClass = ({ seats }) => (
  <StyledContainer data-testid="unavailable-class">
    <StyledWrapper>
      <StyledText>
        <FormattedMessage id="unavailableSeats.klSeats" />{' '}
      </StyledText>
      <strong>{seats.map(({ seat, inventoryClass }) => `${seat} [${inventoryClass}],`)}</strong>
    </StyledWrapper>
  </StyledContainer>
);

UnavailableByClass.propTypes = {
  seats: PropTypes.arrayOf(
    PropTypes.shape({
      seat: PropTypes.string,
      inventoryClass: PropTypes.string
    })
  )
};

export default UnavailableByClass;
